"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const tagStore_1 = require("../../../stores/tag/tagStore");
const i18n_1 = require("../../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'IdHeaderCell',
    props: {
        tableId: null
    },
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.idColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", {
                    key: 0,
                    id: `${__props.tableId}-id-header-cell`,
                    class: "text-left font-bold bg-gray-darker text-white px-4 py-2"
                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('id', 'Id', 'id_header_cell')), 9, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
